export const plServiceTabKey = 'photographer education';
export const infoBannerText = 'view listing';
export const infoBannerHover = 'Opens up your listing page for this service';
